import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ withPaddingBottom: boolean }>()(
  ({ tokens }, { withPaddingBottom }, classes) => ({
    root: {
      overflow: 'hidden',
      paddingBottom: withPaddingBottom ? tokens.spacing['56'] : 0,
      [`& .${(classes as Record<string, string>).endIcon}`]: {
        fontSize: tokens.typography.variant.overline.fontSize,
      },
    },
    endIcon: {},
  }),
);
